import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl } from '@mui/material';

import BaseAutocomplete from '../../../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { useAppDispatch } from '../../../../../../../store/hooks';
import { filterReviewsByRelease } from '../../../store/slices/slices/reviews.slice';
import { useGetReviewFilters } from '../hooks/use-get-review-filters/use-get-review-filters.hook';
import { AllReviewsFiltersProps } from '../types/all-reviews-filters-props';
import withFilterValues from './with-filter-values';

const ReleasesDropdown: FunctionComponent<AllReviewsFiltersProps> = (
  props: PropsWithChildren<AllReviewsFiltersProps>
): ReactElement => {
  const { releases } = useGetReviewFilters();
  const dispatch = useAppDispatch();

  const { setFieldValue, filterValues } = props;

  return (
    <FormControl
      data-testid="releases-dropdown"
      key="release-filter"
      classes={{
        root: 'form-control-main',
      }}
    >
      <BaseAutocomplete
        id="release"
        freeSolo={false}
        multiple={false}
        options={releases}
        value={filterValues?.release || null}
        onChange={(event, value) => {
          setFieldValue('release', value);
          dispatch(filterReviewsByRelease(value ?? ''));
        }}
        renderInput={params => (
          <BaseRenderInput
            {...params}
            id="release"
            label="Release"
            name="release"
            errors={props.errors}
            touched={props.touched}
          />
        )}
      />
    </FormControl>
  );
};

export default withFilterValues(ReleasesDropdown);
